import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SUPPRESS_NOT_FOUND_NOTIFICATION } from 'core';
import { ApproveTaskRequest, EditProductsRequest } from "../task-detail/task-detail.model";
import { Observable } from "rxjs";
import { TaskApprovedResponse } from "../../interfaces/task-approved-response";
import { TaskApprovativo } from "../../interfaces/task-approvativo.model";
import { OrderActivity } from "../../interfaces/order-activity.model";

@Injectable({ providedIn: 'root' })
export class TaskDetailService {

    constructor(private http: HttpClient) {}

    loadTaskDetail(idTask: string): Observable<TaskApprovativo> {
        return this.http.get<TaskApprovativo>(`api/taskapprovativi/${idTask}`);
    }

    approveTask(req: ApproveTaskRequest): Observable<TaskApprovedResponse> {
        const formData = new FormData();

        formData.append('TaskId', req.taskId);
        formData.append('Outcome', req.outcome);
        formData.append('Notes', req.notes ?? '');
        formData.append('Priorita', req.priorita);

        const files = req.allegati ?? [];
        for (const file of files) {
          formData.append('Allegati', file, file.name);
        }
        
        return this.http.post<TaskApprovedResponse>(`api/taskapprovativi/approve`, formData);
    }

    editTaskProducts(req: EditProductsRequest): Observable<unknown> {
        const formData = new FormData();

        formData.append('commento', req.commento);
        // Righe come JSON: nei campi del form i decimali seguirebbero la cultura della richiesta
        formData.append('righe', JSON.stringify(req.righe));

        return this.http.post(`api/ordini/${req.idOrdine}/modificaDaTask`, formData);
    }

    loadOrderActivities(idOrdine: string): Observable<OrderActivity[]> {
        return this.http.get<OrderActivity[]>(`api/ordini/${idOrdine}/attivita`);
    }

    // Il file mancante lo segnala il dettaglio con il suo messaggio
    downloadAttachmentService(idTask: string, idAttachment: string): Observable<any> {
        const url = `api/taskapprovativi/download/${idTask}/${idAttachment}`;
        const context = new HttpContext().set(SUPPRESS_NOT_FOUND_NOTIFICATION, true);
        return this.http.get(url, { responseType: 'blob', context });
    }
}